import { isConsentRequiredIn, isAnalyticsDisabledIn } from '$lib/analytics/consent';
import { locationFromHeaders } from './location';
import { env } from '$env/dynamic/public';

export function getUserContext() {
  if (typeof window === 'undefined') {
    throw Error('getUserContext must be called in the browser');
  }

  return window.__USER_CONTEXT__;
}

export function userContextFrom(
  headers: Headers,
  params?: URLSearchParams
): Window['__USER_CONTEXT__'] {
  let country = locationFromHeaders(headers) ?? '';

  // Allow country override via query param in non-production environments
  if (params && env.PUBLIC_ENVIRONMENT !== 'production') {
    const countryOverride = params.get('country');
    if (countryOverride) {
      country = countryOverride.trim().toUpperCase();
    }
  }

  return {
    analytics: {
      shouldRequestConsent: isConsentRequiredIn(country),
      isDisabled: isAnalyticsDisabledIn(country)
    },
    location: country
  };
}
